import React from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getExamBoardList } from '../../actions/exam_board'
import Loader from '../../components/Loader'
import Empty from '../../components/Empty'
import Search from './Search'
import { deletePublication } from '../../actions/publication';


const defaultFilters = {
    year: 0,
}

export default function Index() {
    const dispatch = useDispatch();
    const { loading, listPublications } = useSelector(state => state.publications);

    const [selectedItem, setSelectedItem] = useState(null);
    const [confirmation, setConfirmation] = useState(false);
    const [filters, setFilters] = useState(defaultFilters);

    const openModal = (data) => () => {
        setSelectedItem(data !== 'add' ? data : {})
    }

    const closeModal = () => setSelectedItem(null)

    const acceptConfirmation = () => {
        if (confirmation?.id) dispatch(deletePublication(confirmation.id, filters));
        setConfirmation(false);
    };
    const rejectConfirmation = () => {
        setConfirmation(false);
    };

    const renderLi = (data) => {
        const { form, name, authors, year, scientometric_base, volume_pp, volume, id, level, place } = data
        return (
            <tr key={id}>
                <td onClick={openModal(data)}>{form}</td>
                <td onClick={openModal(data)}>{name}</td>
                <td onClick={openModal(data)}>{authors}</td>
                <td onClick={openModal(data)}>{year}</td>
                <td onClick={openModal(data)}>{level}</td>
                <td onClick={openModal(data)}>{volume}</td>
                <td onClick={openModal(data)}>{volume_pp}</td>
                <td onClick={openModal(data)}>{scientometric_base}</td>
                <td onClick={openModal(data)}>{place}</td>
                <td>
                    <i
                        className={styles.trash}
                        onClick={() => setConfirmation({ id, name: name })}><BiTrash /></i>
                </td>
            </tr>
        )
    }

    return (
        <div
            className={styles.wrapper}
            style={{
                width: '100%',
                margin: '0 auto'
            }}>
            {confirmation && (<Confirmation
                top="30px"
                left="40px"
                title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
                acceptConfirmation={() => acceptConfirmation(confirmation?.id)}
                rejectConfirmation={rejectConfirmation} />)}

            {selectedItem &&
                <Modal
                    setFilters={setFilters}
                    closeModal={closeModal}
                    data={selectedItem}
                    height={'430px'}
                    addMode={!selectedItem.form}
                    filters={{ filters }}
                />}

            <h1>Публикации, статьи, пособия</h1>

            <Search filters={filters} setFilters={setFilters} getExamBoardList={getExamBoardList} />

            {loading ? <Loader /> : null}

            {!loading && !listPublications?.length
                ? <Empty />
                : <Table className={styles.tables}>
                    <thead>
                        <tr>
                            <th>Вид работы</th>
                            <th>Название</th>
                            <th>Автор(ы)</th>
                            <th>Дата</th>
                            <th>Уровень</th>
                            <th>Объем</th>
                            <th>Печатные листы</th>
                            <th>Наукометрические базы</th>
                            <th>Место публикации</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listPublications && listPublications.map(renderLi)}
                    </tbody>
                </Table>}

            <div
                style={{
                    display: 'flex',
                    flexDirection: "row"
                }}>
                <Button
                    style={{
                        padding: '.5rem 1.5rem',
                        margin: '12px'
                    }}
                    onClick={openModal('add')}>
                    <IoIosAdd size={30} />
                    Добавить
                </Button>
            </div>
        </div>
    )
}
